/**
 * @component GlobalErrorCapture
 * @description Initializes global error capture for production monitoring
 * 
 * Renderless component that sets up window-level error handlers for
 * capturing unhandled errors and promise rejections.
 * 
 * @example
 * // In App.tsx (near root)
 * <GlobalErrorCapture />
 * 
 * @sideEffects
 * - Adds window 'error' event listener
 * - Adds window 'unhandledrejection' event listener
 * 
 * @see initializeErrorCapture - The initialization function
 * @since 1.0.0
 */

import { useEffect } from 'react';
import { initializeErrorCapture } from '@/services/errorCapture';

export function GlobalErrorCapture() {
  useEffect(() => {
    const cleanup = initializeErrorCapture();
    return cleanup;
  }, []);
  
  return null; // This component doesn't render anything
}
